module.exports = __webpack_public_path__ + "static/logo-dumpster-89d7cc9f7fb2986ebbbf6f49b834ce21.png";